export default {"src":"/_next/static/image/public/icons/arrow-big-white.3d6246b90910b38b95c52be34f0054d5.svg","height":30,"width":30};